import { render } from "./SupplierDetailModal.vue?vue&type=template&id=d4cf0612&scoped=true"
import script from "./SupplierDetailModal.vue?vue&type=script&lang=js"
export * from "./SupplierDetailModal.vue?vue&type=script&lang=js"

import "./SupplierDetailModal.vue?vue&type=style&index=0&id=d4cf0612&lang=stylus&scoped=true"
import "./SupplierDetailModal.vue?vue&type=style&index=1&id=d4cf0612&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4cf0612"]])

export default __exports__